const LayerDownSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path
      d="M1.04165 5.20823H9.37498V15.1041H7.29316C7.10292 15.1039 6.9163 15.1559 6.75351 15.2544C6.59073 15.3528 6.45801 15.4939 6.36975 15.6624C6.28149 15.831 6.24107 16.0204 6.25286 16.2103C6.26465 16.4002 6.32821 16.5832 6.43665 16.7395L11.1216 23.5091C11.2176 23.6478 11.3457 23.7611 11.4951 23.8393C11.6444 23.9176 11.8105 23.9585 11.9791 23.9585C12.1478 23.9585 12.3139 23.9176 12.4632 23.8393C12.6126 23.7611 12.7407 23.6478 12.8367 23.5091L17.5216 16.7395C17.6299 16.5831 17.6934 16.4002 17.7051 16.2103C17.7168 16.0205 17.6764 15.8311 17.5882 15.6626C17.4999 15.4942 17.3673 15.3531 17.2046 15.2546C17.0419 15.1561 16.8553 15.1041 16.6651 15.1041H14.5833V5.20823H22.9166C23.1928 5.20791 23.4576 5.09806 23.6529 4.90278C23.8481 4.70749 23.958 4.44273 23.9583 4.16656V1.04156C23.958 0.765387 23.8481 0.50062 23.6529 0.305338C23.4576 0.110056 23.1928 0.000207901 22.9166 -0.000108719L1.04165 -0.000108719C0.765476 0.000207901 0.500708 0.110056 0.305426 0.305338C0.110146 0.50062 0.000295639 0.765387 -2.28882e-05 1.04156V4.16656C0.000295639 4.44273 0.110146 4.70749 0.305426 4.90278C0.500708 5.09806 0.765476 5.20791 1.04165 5.20823Z"
      fill="black"
      fillOpacity="0.95"
    />
  </svg>
);

export default LayerDownSvg;
